/**
 * Submits a POST form that triggers a server redirect.
 *
 * Use this instead of fetch when the server returns 302 redirect with flash messages.
 * Form submit lets the browser handle redirect natively = single request, flash preserved.
 * With fetch + redirect: 'follow', we'd get double load and flash consumed on 1st request.
 *
 * @param action - Form action URL (e.g. copy endpoint)
 * @param csrfToken - Rails authenticity_token for CSRF protection
 */
export function submitPostForm(action: string, csrfToken: string): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;

  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'authenticity_token';
  csrfInput.value = csrfToken;
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
  form.remove();
}
